var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col, fontMediumStyle, Row, TextBody } from '../../atoms';
import { ValidationMessage } from '../validation-message';
export const FormInput = props => {
    const { focused, disabled, label = '', children, maxHeight = 48, onChangePropName = 'onChangeText', onChangeValue, validate, schema, field = 'Name', } = props;
    const [error, setError] = useState(undefined);
    const handleChange = useCallback((newValue) => __awaiter(void 0, void 0, void 0, function* () {
        if (!onChangeValue || newValue === undefined) {
            return;
        }
        if (validate && schema) {
            const { error } = yield validate(field, newValue, schema, label);
            setError(error);
        }
        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(newValue);
    }), [validate, schema, onChangeValue, field, label]);
    const injectedProps = useMemo(() => ({
        onChange: onChangePropName === 'onChange' ? handleChange : undefined,
        // TODO(Hadrien): Can we remove this prop ? unecessary complexity for TextInput
        onChangeText: onChangePropName === 'onChangeText' ? handleChange : undefined,
    }), [onChangePropName, handleChange]);
    // TODO(Hadrien): Implement validation onBlur ? needs passing in the value
    return (_jsx(InputLabel, { label: label, children: _jsxs(Col.LRC, { style: $.validationWrapper, children: [_jsx(Row.LR, { px: "3", py: "2", style: [
                        $.inputContainer,
                        focused && $.focused,
                        !!error && $.errored,
                        disabled && $.disabled,
                        !!maxHeight && { maxHeight },
                    ], children: children(injectedProps) }), _jsx(ValidationMessage, { title: error, variant: "error" })] }) }));
};
const InputLabel = (_a) => {
    var { children, label } = _a, props = __rest(_a, ["children", "label"]);
    const labelProps = Object.assign(Object.assign({}, props), { style: [$.label, $.labelCol] });
    return (_jsxs(Col.LRC, Object.assign({}, labelProps, { style: $.formGroup, children: [label && _jsx(TextBody, { children: label }), children] })));
};
const $ = StyleSheet.create({
    formGroup: {
        position: 'relative',
        rowGap: theme.spacing['2'],
    },
    inputContainer: {
        boxSizing: 'border-box',
        // @ts-expect-error This is web only
        position: 'static',
        borderRadius: Number(theme.radius.sm),
        backgroundColor: theme.color.background.white,
        borderColor: theme.color.border.primary,
        borderWidth: 1,
        paddingBlock: 0,
        paddingInline: 0,
    },
    // @ts-expect-error web specific property
    label: Platform.select({ web: { cursor: 'pointer' }, default: {} }),
    labelCol: { rowGap: theme.spacing['2'] },
    validationWrapper: {
        // @ts-expect-error This is web only
        position: 'static',
        rowGap: theme.spacing['2'],
    },
    focused: {
        borderColor: theme.color.border.tertiary,
    },
    errored: {
        borderColor: theme.color.border.error,
    },
    disabled: {
        borderColor: theme.color.border.tertiary,
    },
    value: Object.assign({}, fontMediumStyle),
});
